import React from 'react';
import styles from './index.module.scss';
import FooterTextComponent from '../footer_text_component';
import DescriptionComponent from '../../../long_text_components/description_component';
import UnknownLongText from '../../../long_text_components/unknown_long_text';
import MainImgComponent from '../../../img_components/main_img_component';
import UnknownImg from '../../../img_components/unknown_img';
import FooterSocialIconsBlock from '../footer_social_icons_block';
import VideoComponent from '../../../video_components/video_component';
import UnknownVideo from '../../../video_components/unknown_video';

const FooterBlock = ({ blockData, path_to_folder, blockIndex, isLastBlock, maxHeight }) => {
  const footerLinks = React.useMemo(() => {
    if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
      return [];
    }

    return blockData.block_content
      .filter(
        (content) =>
          (content.cotent_tag === 'footer_link' || content.content_tag === 'footer_link') &&
          content.content_text !== 'none',
      )
      .map((content) => content.content_text)
      .filter((text) => text && text.trim() !== '');
  }, [blockData]);

  const renderContent = (content) => {
    if (content.cotent_type === 'text' || content.content_type === 'text') {
      if (content.cotent_tag === 'footer_link' || content.content_tag === 'footer_link') {
        return null;
      }

      return (
        <FooterTextComponent
          contentText={content.content_text}
          contentTag={content.cotent_tag || content.content_tag}
          contentName={content.cotent_name || content.content_name}
        />
      );
    }
    if (content.cotent_type === 'long_text' || content.content_type === 'long_text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'description':
          return (
            <DescriptionComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownLongText
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    if (content.cotent_type === 'img' || content.content_type === 'img') {
      switch (content.cotent_tag || content.content_tag) {
        case 'main_img':
          return (
            <MainImgComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownImg
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    if (content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block') {
      return (
        <FooterSocialIconsBlock
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name || content.content_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
          links={footerLinks}
        />
      );
    }
    if (content.cotent_type === 'video' || content.content_type === 'video') {
      switch (content.cotent_tag || content.content_tag) {
        case 'video':
          return (
            <VideoComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownVideo
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }
    return null;
  };

  const isCommonBlock =
    blockData && (blockData.boock_tag === 'Common' || blockData.block_tag === 'Common');

  const isMobile = window.innerWidth <= 768;

  const blockStyles = isCommonBlock
    ? { width: '90%', borderTop: '1px solid #d1d5db', height: 'fit-content', textAlign: 'center' }
    : isMobile
      ? {
          height: 'auto',
          position: 'relative',
          top: 0,
          padding: 0,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }
      : isLastBlock
        ? {
            height: `${maxHeight}px`,
            position: 'relative',
            top: 0,
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }
        : {
            height: `${maxHeight}px`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            top: 0,
            padding: 0,
            margin: 0,
          };

  return (
    <div className={styles.footerBlock} style={blockStyles}>
      {blockData &&
        blockData.block_name &&
        !(blockData.boock_tag === 'Common' || blockData.block_tag === 'Common') && (
          <div className={styles.blockName}>
            <h3 className={styles.name} style={{ marginTop: '20px' }}>
              {blockData.block_name}
            </h3>
          </div>
        )}
      {blockData && blockData.block_content && Array.isArray(blockData.block_content) && (
        <div className={styles.contentContainer}>
          {blockData.block_content.map((content, index) => (
            <div key={index} className={styles.contentWrapper}>
              {renderContent(content)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FooterBlock;
